import fileSVG from '@plone/volto/icons/file.svg';
import EventProgramView from 'iovisit-ferraraterraeacqua/components/Blocks/EventProgram/View';
import EventProgramEdit from 'iovisit-ferraraterraeacqua/components/Blocks/EventProgram/Edit';

import PrenotazioniSVG from '@plone/volto/icons/calendar.svg';
import PrenotazioniView from 'iovisit-ferraraterraeacqua/components/Blocks/Prenotazioni/View';
import PrenotazioniEdit from 'iovisit-ferraraterraeacqua/components/Blocks/Prenotazioni/Edit';
import prenotazioniSchema from 'iovisit-ferraraterraeacqua/components/Blocks/Prenotazioni/schema';

export const FerraraTerraEAcquaBlocks = (config) => {
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    'event-program': {
      id: 'event-program',
      title: 'Programma evento',
      icon: fileSVG,
      group: 'text',
      view: EventProgramView,
      edit: EventProgramEdit,
      restricted: ({ properties, block, contentType }) =>
        contentType !== 'Event' ||
        !!properties.blocks_layout?.items?.find(
          (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
        ),
      mostUsed: false,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    prenotazioni: {
      id: 'prenotazioni',
      title: 'Prenotazioni',
      icon: PrenotazioniSVG,
      group: 'common',
      view: PrenotazioniView,
      edit: PrenotazioniEdit,
      blockSchema: prenotazioniSchema,
      blockHasOwnFocusManagement: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
  };

  config.blocks.initialBlocks = {
    ...config.blocks.initialBlocks,
    Event: ['title', 'slate', 'event-program', 'contacts'],
  };

  return config;
};
